import { apiFactory, headers } from '~/src/dash/api/api-factory';
import { retryFunc } from '~/src/dash/api/console-api';
import { Auth } from '~/src/dash/api/transform-auth';
import { IChangeLog } from '~/src/dash/views/publisher/change-logs/interfaces';
import { transformChangeLog } from '~/src/dash/views/publisher/change-logs/transform';

export const getChangeLogs = apiFactory<{
  changeLogs: IChangeLog[];
  totalChangeLogs: number;
}>({
  method: 'GET',
  headers,
  body: {
    core_section: 'settings',
    core_action: 'change_logs',
  },
  retryCount: 1,
  retryFunc,
  transformQuery: Auth.appendToken,
  transformResponse: (err: any, json: any) => {
    if (err) {
      return new Error((json && json.msg) || 'request failed');
    }
    if (json.changeLogs === null) {
      return {
        changeLogs: [],
        totalChangeLogs: 0,
      };
    }
    return {
      changeLogs: json.changeLogs.map((changeLog: any) => {
        return transformChangeLog(changeLog);
      }),
      totalChangeLogs: json.totalLogs,
    };
  },
});
